module.exports = __webpack_public_path__ + "img/MFT白皮书_14.30e5d55a.jpg";